import { Flex, Grid, Text } from '@radix-ui/themes'
import { episodesInWindow, type LeakV0Window } from './chartWindow'
import { LeakV0ConfigPanel } from './LeakV0ConfigPanel'
import { LeakV0EpisodeTable } from './LeakV0EpisodeTable'
import { LeakV0FreshnessPanel } from './LeakV0FreshnessPanel'
import { LeakV0RawJsonPanel } from './LeakV0RawJsonPanel'
import type { StationLeakV0Status } from './summary'
import type { StationLeakV0Episode } from './useLeakV0Episodes'

export interface LeakV0PanelsProps {
  status: StationLeakV0Status
  /** Every episode on the station, newest onset first. */
  episodes: StationLeakV0Episode[]
  view: LeakV0Window
  selectedEpisodeId: string | null
  now?: Date
}

export const LeakV0NotEnrolledNotice = () => (
  <Text size="2" color="gray">
    This station is not enrolled in the leak detection V0 pilot, so the detector has never run on it.
  </Text>
)

export const LeakV0Panels = ({ status, episodes, view, selectedEpisodeId, now }: LeakV0PanelsProps) => {
  if (!status.enrolled) return <LeakV0NotEnrolledNotice />

  const inView = episodesInWindow(episodes, view)
  const rawEpisode = inView.find((episode) => episode.id === selectedEpisodeId) ?? inView[0] ?? null

  return (
    <Flex direction="column" gap="3">
      <Grid columns={{ initial: '1', md: '2' }} gap="3" align="start">
        <LeakV0ConfigPanel status={status} />
        <LeakV0FreshnessPanel status={status} now={now} />
      </Grid>
      <LeakV0EpisodeTable episodes={episodes} view={view} selectedEpisodeId={selectedEpisodeId} />
      <LeakV0RawJsonPanel episode={rawEpisode} />
    </Flex>
  )
}
